import Fetch from './userTokenFetch'

const apiConfig = {
  setUserToken: `/feapi/passport-api/tujia/cookie/forward`, // 设置用户token
  getUserToken: `/feapi/passport-api/tujia/cookie/user` // 获取用户token
}
const api = {}

api.setUserToken = function() {
  return Fetch.get(apiConfig.setUserToken, { params: arguments[0] })
}

api.getUserToken = function() {
  return Fetch.get(apiConfig.getUserToken, { params: arguments[0] })
}

export default api
